<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
        <!--企业云-->
        <qiyeyun-Form ></qiyeyun-Form>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import qiyeyunForm from "./base/qiyeyunForm";
     export default {
        name: "qiyeyun",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            qiyeyunForm
        }
    }
</script>

<style scoped>

</style>
